import { useEffect, useRef, useState, useMemo } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getUserInviteData, resendInvite, deleteInvite, getJoinedUserData } from '../../Redux/actions';
import { CircularProgress, Tooltip, IconButton, Chip, Box, Pagination } from '@mui/material';
import { paginationStyle, tabStyle, tabListStyle } from '../../theme/formStyles';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import ConfirmDialog from '../Common/ConfirmDialog';
import { green } from '@mui/material/colors';
import { Edit, Refresh } from '@mui/icons-material';
import SearchBox from '../Common/SearchBox';
import { Can, AbilityContext } from '../../Context/Can';
import { useAbility } from '@casl/react';
import { DeleteIcon } from '../Common/TableUI';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import copy from 'copy-to-clipboard';
import AlertDialog from '../Common/AlertDialog';
import { updateParams } from '../../utils';
import { removeNonValueFilter } from '../../utils';
import useBackActionDetection from '../../utils/UseBackActionDetection';

export default function ManageUser() {

    let navigate = useNavigate();
    const location = useLocation();

    const isBackAction = useBackActionDetection();

    const { client_id } = useParams();
    const ability = useAbility(AbilityContext);
    const { currentUser } = useSelector(st => st);
    const allowedEmailsForEmbark = ['accounts@astertechnologies.in', 'aman.mathur@astertechnologies.in'];
    const hasInviteAccess = useMemo(() => {
        return client_id === 'embarkwater-com' && allowedEmailsForEmbark.includes(currentUser?.uniqueId);
    }, [client_id, currentUser]);
    const hasEditAccess = useMemo(() => {
        return client_id === 'embarkwater-com' && allowedEmailsForEmbark.includes(currentUser?.uniqueId);
    }, [client_id, currentUser]);

    const dispatch = useDispatch();
    const [data, setData] = useState(null)
    const [queryParams, setQueryParams] = useSearchParams();
    const existingParams = Object.fromEntries([...queryParams])
    const [showConfirmDialog, setShowConfirmDialog] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const showDeleteIcon = ['Invited', 'Inviting', 'Invite-Error']
    const [hoveredRowId, setHoveredRowId] = useState(null);
    const [showLoader, setShowLoader] = useState(true)
    const [isCopied, setIsCopied] = useState(false);
    const [totalCount, setTotalCount] = useState(0);
    const [totalPages, setTotalPages] = useState(null)
    const [currentPage, setCurrentPage] = useState(null)

    const [alertMessage, setAlertMessage] = useState();
    const [msgType, setMsgType] = useState("success");
    // const [currentTab, setCurrentTab] = useState(queryParams.tab || 0);

    const handleChangeTab = (event, newValue) => {
        // setCurrentTab(newValue);
        setQueryParams({ tab: newValue, page: 1 });
    };

    const fetchData = () => {
        setShowLoader(true)
        const params = {
            title: queryParams.get("search"),
            page: existingParams?.page,
        }
        if (queryParams.get('tab') === 'invited') {
            dispatch(getUserInviteData(client_id, params)).then(res => {
                const response = res.data.data;
                setData(response);
                setTotalCount(res?.data?.totalItems)
                setTotalPages(res?.data?.totalPages)
                setCurrentPage(res?.data?.currentPage)
                setShowLoader(false)
            })
            return
        } else if (queryParams.get('tab') === 'joined') {
            dispatch(getJoinedUserData(client_id, params)).then(res => {
                const response = res?.data?.data;
                setData(response);
                setTotalCount(res?.data?.totalItems)
                setTotalPages(res?.data?.totalPages)
                setCurrentPage(res?.data?.currentPage)
                setShowLoader(false)
            })
        }
    }

    useEffect(() => {
        if (!queryParams.get('tab')) {
            queryParams.set('tab', 'joined');
            navigate({ search: queryParams.toString() }, { replace: true });
        }
        if(!existingParams.page){
            updateQueryParams({ page:1 });
        }
        fetchData()
    }, [ queryParams, client_id, location.search])


    const goToRoutes = (routeApi) => {
        navigate(routeApi, { replace: true });
    }

    const updateQueryParams = (params) => {
        const searchParams = updateParams(existingParams, params)
        navigate({ search: searchParams.toString() }, { replace: true });
    }

    const handleSearch = (value) => {
        updateQueryParams({ search: value, tab: queryParams.get('tab'), page: 1 });
    }

    const handlePageChange = (event, newPage) => {
        updateQueryParams({ page: newPage });
    };

    const handleResend = (user) => {
        dispatch(resendInvite(user)).then((res) => {
        })
    }

    const triggerDelete = (user) => {
        setShowConfirmDialog(true);
        setSelectedItem(user);
    }
    const deleteUserInvite = () => {
        setShowConfirmDialog(false);
        dispatch(deleteInvite(selectedItem)).then((res) => {
           if(!res.data.success) {
               setAlertMessage(res.data.message);
               setMsgType('fail')
           }
            fetchData();
        })
    }

    const handleCopyInvite = (url) => {
        setIsCopied(true);
        setTimeout(() => {
            setIsCopied(false);
          }, 2000);
        copy(url);
    };

    const getStatusClassName = (item) => {
        if (item?.authUser?.status === 'Inactive') {
            return 'w3-red';
        } else if (item.status === 'Joined') {
            return 'w3-green';
        } else if (item.status === 'Invited') {
            return 'w3-yellow';
        } else {
            return 'w3-red'; 
        }
    }
    
    const handleDialogClose = () => {
        setAlertMessage(null);
    };

    const itemsPerPage = 20;
    let userList = [];
    if (showLoader) {
        userList = (
            <TableRow>
                <TableCell colSpan={6} align="center">
                    <CircularProgress />
                </TableCell>
            </TableRow>
        )
    } else if (data?.length > 0) {
        userList = (data?.length > 0 && data?.map((item, index) => (
            <TableRow key={item?.id}
                onMouseEnter={() => {
                    setHoveredRowId(item?.id);
                }}
                onMouseLeave={() => {
                    setHoveredRowId(null);
                }}
            >
                <TableCell>{(currentPage - 1) * itemsPerPage + index + 1}</TableCell>
                <TableCell>{queryParams.get('tab') === 'invited' ? item?.name : item?.name}</TableCell>
                <TableCell style={{ maxWidth: '250px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{queryParams.get('tab') === 'invited' ? item?.emailId : item?.user_id}</TableCell>
                {/* <TableCell>{Object.keys(item?.json)
                .filter(key => item?.json[key])
                .join(', ')}</TableCell> */}
                <TableCell>
                <Chip
                    size="small"
                    className={getStatusClassName(item)}
                    label={item?.authUser?.status === 'Inactive' ? 'Deactivated' : item.status}
                />
                </TableCell>
                <TableCell>
                 <Box component="div" display="flex" justifyContent={"right"}>

                    {(ability.can('manage', 'EditClientUser') || hasEditAccess) && (
                        <Tooltip title="Edit">
                            <IconButton aria-label="edit"
                                style={{ opacity: hoveredRowId === item?.id ? 1 : 0, paddingLeft: '0px' }}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    localStorage.setItem('customerUsersQueryParams', queryParams);
                                    navigate(`/client/${client_id}/users/invite/edit/${item?.id}`, { state: { status: queryParams.get('tab') } })
                                }}>
                                <Edit className="cursor-pointer"
                                    style={{ color: 'black'}}
                                />
                            </IconButton>
                        </Tooltip>
                    )}
                    <Can do="manage" on="DeleteClientUser">
                        {showDeleteIcon.includes(item?.status) && <Tooltip title="Delete">
                            <IconButton aria-label="delete"
                                style={{ opacity: hoveredRowId === item?.id ? 1 : 0 }}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    triggerDelete(item?.id)
                                }}
                            > 
                                <DeleteIcon/>

                            </IconButton>
                        </Tooltip>}
                    </Can>
                    {item?.status === 'Invite-Error' && <Can do="manage" on="ClientUserInvite">
                    <Tooltip title="Resend Email">
                        <IconButton aria-label="resend"
                            onClick={(e) => {
                                e.stopPropagation();
                                handleResend(item);
                            }}>
                            <Refresh className="cursor-pointer"
                                style={{ color: green[500] }}
                            />
                        </IconButton>
                    </Tooltip></Can>}

                    {item?.status === 'Invited' && (
                        <Can do="manage" on="CopyUserInvite">
                            <Tooltip 
                            title={isCopied ? 'Link copied!' : 'Copy invite link'}
                            arrow
                            >
                                <IconButton aria-label="copy"
                                    style={{ opacity: hoveredRowId === item?.id ? 1 : 0 }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        const url = window.location.href;
                                        const parsedUrl = new URL(url);
                                        const host = parsedUrl.origin;
                                        handleCopyInvite(host + `/invite/${item?.token}`);
                                    }}> 
                                    <ContentCopyIcon/>
                                </IconButton>
                            </Tooltip>
                        </Can>
                    )}
                    </Box>
                </TableCell>
            </TableRow>
        )))
    } else {
        userList = (<TableRow>
            <TableCell colSpan={6} align="center">
                <h5 className='w3-text-grey'>
                    No Data Found
                </h5>
            </TableCell>
        </TableRow>)
    }

    return (
        <Grid container>
            <Grid item md={12}>
                <Grid container item md={12} >
                    <Grid item container md={12} paddingY={2} paddingX={3}>
                        <Grid item  md={6}>
                            {(ability.can('manage', 'ClientUserInvite') || hasInviteAccess) && (
                                <Button
                                    style={{ backgroundColor: '#008080', color: 'white'}}
                                    variant="contained"
                                    onClick={() => {
                                        if (localStorage.getItem('customerUsersQueryParams')) {
                                            localStorage.removeItem('customerUsersQueryParams');
                                        }
                                        navigate(`/client/${client_id}/users/invite`, { state: { status: queryParams.get('tab') } });
                                    }}
                                >
                                    Invite User
                                </Button>
                            )}
                        </Grid>
                        <Grid item container md={6} justifyContent={"flex-end"}>
                            <h6 style={{ paddingRight: '5px', fontSize: '15px' }}>Search By: </h6>
                            <SearchBox
                                value={queryParams.get('search') || ''}
                                placeholder='User Name'
                                search={handleSearch}
                                isBrowserBackAction={isBackAction}
                            />
                        </Grid>
                    </Grid>
                    <Tabs value={queryParams.get('tab')} onChange={handleChangeTab} style={{ marginLeft: '24px' }} sx={tabListStyle}>
                        <Tab disabled={showLoader} label="Joined Users" value="joined" sx={tabStyle} />
                        <Tab disabled={showLoader} label="Invited Users" value="invited" sx={tabStyle} />
                    </Tabs>
                </Grid>
                <div className='w3-padding-large'>
                    <TableContainer component={Paper}>
                        <Table aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell className='client-table-head'> Sl.No.</TableCell>
                                    <TableCell className='client-table-head'> Name</TableCell>
                                    <TableCell className='client-table-head'>Email Id</TableCell>
                                    {/* <TableCell>Permissions</TableCell> */}
                                    <TableCell className='client-table-head'>Status</TableCell>
                                    <TableCell className='client-table-head'></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {userList}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    {data && (data?.length > 0) && !showLoader && (<Grid container item xs={12} style={{ marginBottom: '30px', marginTop: '12px' }}>
                        {/* Items Per Page Information */}
                        <Grid item xs={12} display="flex" justifyContent="end" style={{ marginBottom: '10px' }}>
                            <span style={{ fontFamily: '"Helvetica Neue"', fontSize: '13px', color: '#3d3d3d' }}>
                                {Math.min((parseInt(existingParams.page ? existingParams.page : 1 ) - 1) * itemsPerPage + 1, totalCount)}-
                                {Math.min(parseInt(existingParams.page ? existingParams.page : 1 ) * itemsPerPage, totalCount)} of {totalCount}
                            </span>
                        </Grid>
                        {/* Pagination Controls */}
                        <Grid item xs={12} display="flex" justifyContent="center">
                            <Pagination className='pagination'
                                page={parseInt(existingParams?.page) || 1}
                                count={totalPages}
                                variant="outlined"
                                shape="rounded"
                                sx={paginationStyle}
                                onChange={handlePageChange}
                            />
                        </Grid>
                    </Grid>)}
                </div>
            </Grid>
            {showConfirmDialog
                ? (
                    <ConfirmDialog
                        handleCancel={() => {
                            setSelectedItem({})
                            setShowConfirmDialog(false)
                        }}
                        handleOk={deleteUserInvite}
                        message={'Are you sure to delete this user?'}
                    />
                ) : null}
                {alertMessage ? (
                <AlertDialog
                    handleClose={() => setAlertMessage(null)}
                    message={alertMessage}
                    type={msgType}
                    handleDialogClose={handleDialogClose}
                />) : null}
        </Grid>
    )
}




